// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { B100, B400, B50, N20, N200, N300 } from '@atlaskit/theme/colors';
var listItemBaseStyles = css({
  display: 'flex',
  paddingTop: "var(--ds-space-100, 8px)",
  paddingBottom: "var(--ds-space-100, 8px)",
  paddingLeft: "clamp( ".concat("var(--ds-space-100, 8px)", ", var(--link-picker-padding-left), 100% )"),
  paddingRight: "clamp( ".concat("var(--ds-space-100, 8px)", ", var(--link-picker-padding-right), 100% )"),
  margin: 0,
  cursor: 'pointer'
});
var listItemFocusStyles = css({
  '&:focus': {
    outline: 'none',
    boxShadow: "0 0 0 2px ".concat("var(--ds-border-focused, ".concat(B100, ")"), " inset"),
    textDecoration: 'none'
  }
});
var listItemBoxShadow = css({
  boxShadow: "inset 2px 0px 0px ".concat("var(--ds-border-selected, ".concat(B400, ")"))
});
var listItemActive = css({
  '&:hover': {
    backgroundColor: "var(--ds-background-neutral-subtle-hovered, ".concat(N20, ")")
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  listItemBoxShadow: listItemBoxShadow
});
var listItemSelected = css({
  backgroundColor: "var(--ds-background-selected, ".concat(B50, ")")
},
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
listItemBoxShadow);
export var composeListItemStyles = function composeListItemStyles() {
  var selected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return css(
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  listItemBaseStyles,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  !selected && listItemActive,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  selected && listItemSelected,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  listItemFocusStyles);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var itemNameStyles = css({
  overflow: 'hidden',
  alignContent: 'center',
  width: '100%'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var listItemContextStyles = css({
  color: "var(--ds-text, ".concat(N300, ")"),
  font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
  display: 'flex'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var listItemContainerStyles = css({
  overflow: 'hidden',
  textOverflow: 'ellipsis'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var listItemContainerInnerStyles = css({
  color: "var(--ds-text-subtlest, ".concat(N200, ")"),
  whiteSpace: 'nowrap'
});

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var itemIconStyles = css({
  minWidth: "var(--ds-space-200, 16px)",
  marginTop: "var(--ds-space-050, 4px)",
  marginRight: "var(--ds-space-150, 12px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var imgStyles = css({
  maxWidth: "var(--ds-space-200, 16px)"
});